import { DisplayAuthoringPropertyPipe, GetPlatformNamePipe, InheritPipe, IsMacOrLinuxPipe, IsRequiredPropertyPipe, IsSoftwareProductPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { GeneralPropertiesComponent } from './general-properties.component';

const WIDGETS: Type<any>[] = [
	CardComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	InputComponentModule,
	ToggleSwitchComponent,
	ComboComponentModule,
	AuthoringPropertyLabelComponentModule
];

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	GetPlatformNamePipe,
	InheritPipe,
	IsMacOrLinuxPipe,
	IsRequiredPropertyPipe,
	IsSoftwareProductPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [GeneralPropertiesComponent],
	exports: [GeneralPropertiesComponent]
})
export class GeneralPropertiesComponentModule {

}
